<script setup>
import { useRoute } from "vue-router";

const route = useRoute();

// console.log(route.matched.slice());
</script>

<template>
  <breadcrumb list-classes="breadcrumb-links breadcrumb-dark">
    <breadcrumb-item>
      <li class="breadcrumb-item">
        <router-link to="/">
          <i class="fas fa-home"></i>
        </router-link>
      </li>
    </breadcrumb-item>

    <template v-for="(r, index) in route.matched.slice()" :key="index">
      <breadcrumb-item
        v-if="r.name"
        :active="index === route.matched.length - 1"
        style="display: inline-block"
      >
        <router-link
          :to="{ name: r.name }"
          v-if="index < route.matched.length - 1"
        >
          {{ r.name }}
        </router-link>
        <span v-else>{{ r.name }}</span>
      </breadcrumb-item>
    </template>
  </breadcrumb>
</template>

<style scoped></style>
